var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { css, html, LitElement } from "lit";
import { customElement } from "lit/decorators.js";
let ESLogo = class ESLogo extends LitElement {
    render() {
        return html `
      <svg
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        viewBox="0 0 100 36"
        class="es-logo"
        role="img"
        aria-label="Exact Sciences"
      >
        <title>Exact Sciences</title>
        <path
          d="M10.6089 0.142871V3.01087H3.14234V6.3247H10.0344V9.08699H3.14234V12.6996H10.6933V15.5676H0V0.142871H10.6089Z"
          fill="black"
        />
        <path
          d="M16.699 7.64373C16.6474 7.68509 16.5982 7.72875 16.5489 7.77012C14.3305 5.95004 12.5155 3.43595 12.5155 0.145099H15.8102C15.8102 2.42709 16.7178 4.12996 18.8987 5.8857C18.8658 5.91327 18.8353 5.93855 18.8002 5.96613L16.699 7.64373Z"
          fill="black"
        />
        <path
          d="M21.2569 7.56619C21.2147 7.60146 21.1677 7.65109 21.1231 7.68636L19.0277 9.41065C18.9793 9.44977 18.9423 9.47772 18.8985 9.51544C21.0654 11.3118 22.0081 13.2398 21.9869 15.5676H25.2817C25.3052 12.2311 23.466 9.43544 21.2569 7.56619Z"
          fill="black"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M21.7559 0.145117C21.7559 2.42334 20.8753 4.1234 18.7591 5.87623C18.7272 5.90376 18.6976 5.92899 18.6635 5.95652L16.6224 7.63135C16.5723 7.67265 16.5245 7.71624 16.4767 7.75753C14.3332 9.58149 12.5628 12.2864 12.5628 15.542H15.7599C15.7395 13.273 16.6542 11.3917 18.7568 9.63655C18.7955 9.60443 18.8319 9.57001 18.8728 9.53789L20.914 7.86307C20.9572 7.82866 20.9982 7.79195 21.0391 7.75524C23.1918 5.93817 24.953 3.42823 24.953 0.142822H21.7559V0.145117Z"
          fill="#A275FF"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M40.5293 15.5675H37.19L36.1933 12.3157H30.4269L29.4303 15.5675H26.1566L31.0554 0.142822H35.6305L40.5293 15.5675ZM33.3087 2.91662L31.2779 9.53278H35.3395L33.3087 2.91662Z"
          fill="black"
        />
        <path
          d="M41.2582 9.74786V5.94238C41.2582 2.62552 43.6456 0.142822 47.3424 0.142822C51.0797 0.142822 53.3009 2.54408 53.3009 5.84114H50.2689C50.2262 3.99012 49.1886 2.86982 47.3402 2.86982C45.4514 2.86982 44.3082 4.11117 44.3082 6.10525V9.6048C44.3082 11.6187 45.4491 12.86 47.3402 12.8402C49.1886 12.86 50.2262 11.7419 50.2689 9.86891H53.3009C53.3009 13.2056 51.0797 15.587 47.3424 15.5672C43.6479 15.587 41.2582 13.1043 41.2582 9.74786Z"
          fill="black"
        />
        <path
          d="M66.1895 0.142847V3.01085H61.8747V15.5675H58.7089V3.01085H54.394V0.142847H66.1895Z"
          fill="black"
        />
        <path
          d="M11.4128 25.1052V25.39H8.35184V25.2067C8.35184 23.9618 7.45539 23.1451 5.74809 23.1451C4.33134 23.1451 3.50021 23.8382 3.52048 24.7366C3.54075 25.9197 4.99804 26.2265 6.58147 26.615L7.0815 26.7364C10.0592 27.4714 11.7665 28.7561 11.7867 31.1841C11.807 34.1021 9.49606 35.8569 6.16478 35.8569C2.45735 35.8569 0 33.8968 0 30.4292V30.4093H3.06099V30.5528C3.06099 32.2259 4.28854 33.1243 6.16478 33.1243C7.66487 33.1243 8.70547 32.5327 8.70547 31.4512C8.70547 30.3299 7.80902 29.9811 5.72782 29.4712L5.22779 29.3498C2.124 28.5949 0.459487 27.4317 0.439215 24.9838C0.418944 22.3726 2.6871 20.4324 5.81115 20.4324C9.24829 20.4324 11.4128 22.3902 11.4128 25.1052Z"
          fill="black"
        />
        <path
          d="M13.8277 30.0374V26.2319C13.8277 22.9151 16.2151 20.4324 19.9119 20.4324C23.6491 20.4324 25.8704 22.8337 25.8704 26.1307H22.8384C22.7979 24.2797 21.7581 23.1594 19.9097 23.1594C18.0208 23.1594 16.8776 24.4007 16.8776 26.3948V29.8944C16.8776 31.9082 18.0186 33.1496 19.9097 33.1298C21.7581 33.1496 22.7957 32.0315 22.8384 30.1585H25.8704C25.8704 33.4951 23.6491 35.8766 19.9119 35.8568C16.2151 35.8788 13.8277 33.3961 13.8277 30.0374Z"
          fill="black"
        />
        <path
          d="M31.2227 35.8571H28.0569V20.4324H31.2227V35.8571Z"
          fill="black"
        />
        <path
          d="M44.6034 20.4324V23.3004H37.1368V26.6142H44.0289V29.3765H37.1368V32.9891H44.6878V35.8571H33.9922V20.4324H44.6034Z"
          fill="black"
        />
        <path
          d="M56.088 20.4324V30.2383L49.9088 20.4324H46.8743V35.8571H49.9956V26.0489L56.1747 35.8571H59.2092V20.4324H56.088Z"
          fill="black"
        />
        <path
          d="M61.76 30.0374V26.232C61.76 22.9151 64.1474 20.4324 67.8443 20.4324C71.5815 20.4324 73.8027 22.8337 73.8027 26.1307H70.7707C70.7303 24.2797 69.6904 23.1594 67.842 23.1594C65.9532 23.1594 64.81 24.4008 64.81 26.3948V29.8944C64.81 31.9083 65.9509 33.1496 67.842 33.1298C69.6904 33.1496 70.728 32.0315 70.7707 30.1585H73.8027C73.8027 33.4952 71.5815 35.8766 67.8443 35.8568C64.1474 35.8788 61.76 33.3961 61.76 30.0374Z"
          fill="black"
        />
        <path
          d="M86.671 20.4324V23.3004H79.2067V26.6142H86.0988V29.3765H79.2067V32.9891H86.7577V35.8571H76.062V20.4324H86.671Z"
          fill="black"
        />
        <path
          d="M99.626 25.1052V25.39H96.565V25.2068C96.565 23.9619 95.6685 23.1452 93.9612 23.1452C92.5445 23.1452 91.7133 23.8383 91.7336 24.7366C91.7539 25.9197 93.2112 26.2265 94.7946 26.615L95.2946 26.7364C98.2723 27.4715 99.9796 28.7561 99.9999 31.1841C100.02 34.1021 97.7092 35.8569 94.3779 35.8569C90.6705 35.8569 88.2154 33.8969 88.2154 30.4292V30.4094H91.2764V30.5528C91.2764 32.226 92.5039 33.1243 94.3779 33.1243C95.878 33.1243 96.9186 32.5328 96.9186 31.4512C96.9186 30.3299 96.0221 29.9811 93.9409 29.4713L93.4409 29.3499C90.3371 28.595 88.6726 27.4317 88.6523 24.9838C88.6321 22.3726 90.9002 20.4324 94.0243 20.4324C97.4592 20.4324 99.626 22.3903 99.626 25.1052Z"
          fill="black"
        />
      </svg>
    `;
    }
};
ESLogo.styles = [
    css `
      .es-logo {
        width: 100%;
      }
    `,
];
ESLogo = __decorate([
    customElement("es-logo")
], ESLogo);
export { ESLogo };
